import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import s from '../layouts/Layout.module.css';

/** Текстовый логотип «dodoc.kz» (фирменного логотипа пока нет — DESIGN.md, «Пробелы»). */
export function Logo({ to = '/' }: { to?: string }) {
  const { t } = useTranslation('shell');
  return (
    <Link to={to} className={s.logo} aria-label={t('logo.home')}>
      <span aria-hidden="true">dodoc</span>
      <span className={s.logoTld} aria-hidden="true">
        .kz
      </span>
    </Link>
  );
}
